<template>
<div class="dsb-router-wrapper">
    <div class="dsb-router-header">
        <div class="dsb-title dsb-title-lg">
            <p>Wo sind deine Daten?</p>
        </div>
    </div>
    
    <Loader v-if="loadingData" />
    <div class="notifications-wrapper" v-else>
        <div class="notifications-list-wrapper">
            <div class="header">
                <div class="counter" v-if="ticketsReplyData">
                    <p>Aktiv {{ticketsReplyData.length}}</p> 
                </div>

                <div class="collapse-btn">
                    <img src="../../assets/icons/arrow_icon.svg" />
                </div>
            </div>

            <div class="notifications-list" :class="{'no-notifications' : ticketsReplyData.length == 0 }"> 
                <div 
                    v-for="notification in ticketsReplyData" :key="notification.id"
                    class="notification "  
                    @click=" setActiveNotification(notification.id)" 
                    :class="{'notification-active' :  activeNotification && activeNotification.id == notification.id}"
                >
                    <div class="company-img"> 
                        <img src="../../assets/icons/connection_default_icon.svg" />
                    </div>
                    <div class="about">
                        <div class="company">
                            <p v-if="notification.company">{{ notification.company.name }} </p> 
                        </div>
                        <div class="recieved-date">
                            <p>{{ notification.latestUpdateDate }}</p>
                        </div>
                    </div>
                </div>
                 
                <div v-if="ticketsReplyData.length == 0" class="no-data">
                    <img src="../../assets/icons/empty_icon.png" />
                </div>
            </div>
        </div>
        <div class="noticications-details" v-if="activeNotification" data-aos="fade-left">
            <div class="header" v-if="!mobile">
                <div class="about">
                    <div class="company dsb-title dsb-title-sm">
                        <p v-if="activeNotification.company">{{activeNotification.company.name}}</p>
                    </div>
                    <div class="status">
                        <p v-if="activeNotification.status">{{activeNotification.status.name}} – Anfrage gesendet am {{activeNotification.openDate}}</p>
                    </div>
                </div>

                <div class="option-btn">
                    ...
                </div>
            </div>

            <div v-if="isUserSubbed">
                <div class="details"> 
                    <p v-html="activeNotification.body.replace(/\n/g, '<br>')"></p> 
                </div>
 
                <div class="notification-files-wrapper">
                    <div class="notification-files">
                        <div class="file" v-for="file in limitedFiles" :key="file.id" @click="downloadFile(activeNotification.id, file)">
                            <img v-if="file.extension === 'pdf'" src="../../assets/icons/pdf-icon.svg" />
                            <img v-if="file.extension === 'jpg'" src="../../assets/icons/jpg-icon.svg" />
                            <img v-if="file.extension === 'png'" src="../../assets/icons/png-icon.svg" />
                            <img v-if="file.extension === 'docx'" src="../../assets/icons/docx-icon.svg" />
                            <p>{{ file.name }}</p>
                        </div>
                    </div>

                    <button v-if="activeNotification.files.length > maxFilesToShow" class="files-toggle-btn" :class="{'active': !showAllFiles}" @click="showAllFiles = !showAllFiles">
                        <img src="../../assets/icons/arrow_icon_white.svg" />
                    </button>
                </div>

                <div class="notification-footer" :class="{ 'justify-end': activeNotification.files && activeNotification.files.length > 0 }">
                    <button v-if="activeNotification.files && activeNotification.files.length > 0" @click="downloadMultipleFiles(activeNotification.id, activeNotification.files)" class="dsb-btn dsb-btn-sm download-btn">
                        <p>Alle Dateien herunterladen</p>
                    </button>
                    <div class="action-btns">
                        <button @click="updateReplyStatus(activeNotification.id, 7)" class="dsb-btn dsb-btn-sm ">
                            <p>Nicht löschen</p>
                        </button>
                        <button @click="updateReplyStatus(activeNotification.id, 4)" class="dsb-btn dsb-btn-sm dsb-btn-light">
                            <p>Löschen</p>
                        </button>
                    </div>
                </div>
            </div>
            <div v-else class="no-subscription-wrapper">
                <div class="details">
                    <p>
                        In Ihrer E-Mail fordern Sie uns in Ihrer Funktion als Geschäftsführer der Adits GmbH auf, der Adits GmbH „alle Klienten betreffenden“ Personendaten auf Grundlage von Art. 25 DSG zu beauskunften. Wir weisen darauf hin, dass der Auskunftsanspruch nach Art. 25 DSG ein höchstpersönliches, subjektives Recht ist, das ausschliesslich jeder individuell „betroffenen Person“ im Sinne von Art. 5 lit. c DSG zusteht. Einer juristischen Person steht ein entsprechender Anspruch nicht zu. Wer einer Ihrer „Klienten“ sein könnte, entzieht sich ohnehin unserer Kenntnis. Wir sehen daher mangels Rechtsgrundlage keine Veranlassung, der Adits GmbH Auskunft zu erteilen. Zusätzlich erfassen wir keine Daten über Benutzer, mit Ausnahme derjenigen, die sich entscheiden, sich auf unserer Website zu registrieren. Wir haben eine kurze Überprüfung durchgeführt und können keinen registrierten Benutzer unter Ihrem Namen, Email-Adresse, oder Ihrer Unternehmensdomain finden. Ich hoffe, das hilft. Mit freundlichen Grüßen,
                    </p>
                </div>
                <div class="notification-files-wrapper">
                    <div class="notification-files">
                        <div class="file" v-for="file in sampleFiles" :key="file.id">
                            <img v-if="file.type == 'pdf'" src="../../assets/icons/pdf-icon.svg" />
                            <img v-if="file.type == 'jpg'" src="../../assets/icons/jpg-icon.svg" />
                            <img v-if="file.type == 'png'" src="../../assets/icons/png-icon.svg" />
                            <img v-if="file.type == 'docx'" src="../../assets/icons/docx-icon.svg" />
                            <p>{{file.name}}.{{ file.type }}</p>
                        </div>
                    </div>

                    <button class="files-toggle-btn">
                        <img src="../../assets/icons/arrow_icon_white.svg" />
                    </button>
                </div>
                <div class="notification-footer">
                    <button class="dsb-btn dsb-btn-sm download-btn">
                        <p>Alle Dateien herunterladen</p>
                    </button>
                    <div class="action-btns">
                        <button class="dsb-btn dsb-btn-sm ">
                            <p>Nicht löschen</p>
                        </button>
                        <button class="dsb-btn dsb-btn-sm dsb-btn-light">
                            <p>Löschen</p>
                        </button>
                    </div>
                </div>

                <div class="no-subscription">
                    <h3>Uff! Wir haben private Daten<br> wurden gefunden 😨</h3>

                    <p class="message">
                        Du kannst die Basisversion kostenfrei nutzen. Für mehr Details haben wir unseren Premium-Zugang. Wir benötigen Einnahmen aus der Detailauskunft, um den Service für möglichst viele Menschen kostenlos anzubieten.
                    </p>

                    <button class="dsb-btn dsb-btn-sm ">
                        <p>Zu den Abos</p>
                    </button>
                </div>
            </div>
        </div>

        <div v-else class="no-data-msg  dsb-title dsb-title-sm">
            <p v-if="ticketsReplyData.length == 0">
                Keine News
            </p> 
        </div>
    </div>

    <DeleteDataRequest v-if="deleteDataRequestModal"/>
</div>
</template>

<script>
import Loader from '../../components/Loader.vue';
import DeleteDataRequest from '../../components/dashboard/DeleteDataRequest.vue';
export default {
    components: {
        Loader,
        DeleteDataRequest
    },
    data() {
        return { 
            isUserSubbed: true,
            loadingData: false,

            activeNotification: null,

            showAllFiles: false,

            mobile: false,

            maxFilesToShow: 6,

            sampleFiles: [{
                    id: 1,
                    type: 'pdf',
                    name: 'file1'
                },
                {
                    id: 2,
                    type: 'jpg',
                    name: 'file2'
                },
                {
                    id: 3,
                    type: 'png',
                    name: 'file3'
                },
                {
                    id: 4,
                    type: 'docx',
                    name: 'file4'
                },
            ]
        }
    },
    computed: {
        limitedFiles() {
            if (!this.activeNotification || !this.activeNotification.files || this.activeNotification.files.length <= 0) return [];
            return this.showAllFiles ?
                this.activeNotification.files :
                this.activeNotification.files.slice(0, this.maxFilesToShow);
        }
    },
    methods: {
        updateReplyStatus(id, newStatus){
            this.activeNotification = null;
            this.$store.commit("application/setDeleteDataRequestModal", true);
            this.$store.commit("application/setTicketId", id);
            this.$store.commit("application/setTicketStatus", newStatus);
        },

        async downloadMultipleFiles(ticketId, files) { 
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                this.downloadFile(ticketId, file);
                await new Promise(resolve => setTimeout(resolve, 500));
            }
        },

  
        async downloadFile(ticketIdValue, fileObject) {
            try {
                const response = await this.getTicketFile({
                    ticketId: ticketIdValue,
                    fileId: fileObject.id
                });

                const fileName = fileObject.name || `download_${ticketIdValue}_${fileObject.id}.bin`;

                if (response && response.data) {
                    const blobUrl = URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.download = fileName;

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(blobUrl);
                } else { 
                    this.$store.commit("application/setErrorProcessModal", true);
                    this.$store.commit("application/setErrorProcessTitle", 'Keine Dateidaten empfangen.');
                    this.$store.commit("application/setErrorProcessText", null);
                }
            } catch (error) {
                this.$store.commit("application/setErrorProcessModal", true);
                this.$store.commit("application/setErrorProcessTitle", 'Beim Herunterladen der Datei ist ein Fehler aufgetreten!');
                this.$store.commit("application/setErrorProcessText", this.$store.state.tickets.ticketsError || "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.");
            }
        },

     
        checkIfMobile() {
            if (window.innerWidth <= 834) {
                this.mobile = true;
            } else {
                this.mobile = false;
            }
        }, 

        async setActiveNotification(id) {
            this.loadingData = true;
            this.activeNotification = null;
            await this.getTicketReply(id);
            this.activeNotification = this.ticketReply.data.data;
            this.loadingData = false;
        },

        setMaxFilesBasedOnViewport() {
            const width = window.innerWidth;

            if (width <= 570) {
                this.maxFilesToShow = 3;
            } else if (width <= 695) {
                this.maxFilesToShow = 4;
            } else if (width <= 800) {
                this.maxFilesToShow = 3;
            } else if (width <= 1200) {
                this.maxFilesToShow = 4;
            } else if (width <= 1730) {
                this.maxFilesToShow = 5;
            } else {
                this.maxFilesToShow = 6;
            }
        }
    },
    async mounted() {
        this.loadingData = true;

        const isVerified = await this.checkUserIdentity();

        if (isVerified) {
            try {
                this.loadingData = true;
                await this.getTicketsReplyData();
                //this.notifications = this.ticketsReplyData;
                
                if(this.ticketsReplyData.length > 0){ 
                    const routeId = this.$route.params.id;

                    if (routeId) { 
                        const found = this.ticketsReplyData.find(n => n.id == routeId);
                        if (found) {
                            await this.setActiveNotification(found.id);
                        } 
                        
                        else { 
                            await this.setActiveNotification(this.ticketsReplyData[0].id);
                        }
                    }else { 
                        await this.setActiveNotification(this.ticketsReplyData[0].id);
                    }
                 }
            } catch (err) {
                this.$store.commit("application/setErrorProcessModal", true);
                this.$store.commit("application/setErrorProcessTitle", 'Beim Abrufen der Daten ist ein Fehler aufgetreten!');
                this.$store.commit("application/setErrorProcessText", this.ticketsError || "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.");
                this.loadingBtn = false;
            }

        }

        this.setMaxFilesBasedOnViewport();

        this.checkIfMobile();

        window.addEventListener("resize", this.checkIfMobile);

        window.addEventListener('resize', this.setMaxFilesBasedOnViewport);

        this.loadingData = false;
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.checkIfMobile);
    },

}
</script>

<style lang="scss" scoped>
@import "../../assets/dashboard.scss";

.justify-end {
    justify-content: flex-end;
}

.no-notifications {
    min-height: 30vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

.no-data-msg {
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
        color: #000000;
        font-weight: 500;
    }
}

.no-subscription-wrapper {
    position: relative;

    .details {
        opacity: 0.05;
    }

    .notification-files-wrapper {
        opacity: 0.05;
    }

    .notification-footer {
        opacity: 0.1;
    }
}

.no-subscription {
    position: absolute;
    top: 0%;
    left: 0%;
    width: 90%;
    margin: 0 5%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    h3 {
        font-size: 32px;
        color: #000000;
    }

    .message {
        color: #000000;
        font-size: 14px;
        margin-top: 10px;
        margin-bottom: 20px;
    }

    button {
        width: 180px !important;

        p {
            font-size: 14px !important;
        }
    }
}

.notifications-wrapper {
    box-shadow: 4px 6px 14px #56597A4D;
    border-radius: 20px;
    display: flex;
    width: 100%;
}

.notifications-list-wrapper {
    padding: 36px 20px;
    border: 1px solid transparent;
    border-right-color: #7070704d;

    width: 30%;

    .header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 23px;

        .counter {
            p {
                font-size: 18px;
                color: #000000;
            }
        }
    }

    .notifications-list {
        width: 100%; 

        .notification {
            width: 100%;
            border: 1px solid #3d3d3d26;
            border-radius: 20px;
            padding: 12px; 
            cursor: pointer;
            transition: 0.3s ease;
            margin-bottom: 20px;

            display: flex;
            align-items: center;
            gap: 15px; 

            &:last-child {
                margin-bottom: 0 !important;
            }

            &-active,
            &:hover {
                background-color: #3d3d3d26;
                border: 1px solid transparent;
            }

            .company-img {
                width: 44px;
                height: 44px;

                img {
                    width: 100%;
                }
            }

            .about {
                .company {
                    margin-bottom: 3px;

                    p {
                        font-size: 18px;
                        font-weight: 500;
                        color: #000000;
                    }
                }

                .recieved-date {
                    p {
                        font-size: 14px;
                        color: #666666;
                    }
                }
            }
        }
    }

}

.noticications-details {
    width: 70%;

    .header {
        padding: 30px 35px;
        border: 1px solid transparent;
        border-bottom-color: #7070704d;

        display: flex;
        justify-content: space-between;
        align-items: center;

        .about {
            .company {
                margin-bottom: 3px;
            }

            .status {
                p {
                    font-size: 14px;
                    color: #666666;
                }
            }
        }
    }

    .details {
        padding: 15px 35px;
        padding-bottom: 80px;
        border: 1px solid transparent;
        border-bottom-color: #7070704d;

        p {
            font-size: 15px;
            color: #666666;
        }
    }
}

.action-btns {
    display: flex;
    gap: 20px;
    justify-content: flex-end;
    align-items: center;

    .dsb-btn {
        margin: initial;

        p {
            font-size: 16px;
        }
    }
}

.notification-footer {
    padding: 26px 36px;
    padding-top: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.download-btn {
    margin: 0;
    width: 224px;
}

.notification-files {
    padding: 26px 36px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 35px;
    width: 95%;

    .file {
        display: flex;
        align-items: center;
        gap: 10px;
        transition: 0.3s ease;
        cursor: pointer;

        img {
            width: 20px;
            height: 28px;
        }

        p {
            color: #FF3A67;
            font-size: 12px;
        }
    }
}

.files-toggle-btn {
    width: 22px;
    height: 22px;
    background-color: #666666;
    border: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    // top: 50%;  
    top: 26px;
    right: 22px;
    // transform: translate(-50%, -50%);
    transition: 0.3s ease;
    cursor: pointer;

    &.active {
        img {
            transform: rotate(180deg);
        }
    }

    img {
        transition: 0.3s ease;
        width: 50%;
    }
}

.notification-files-wrapper {
    position: relative;
}

/* imac 24" */
/* 2048 x 1152 */
@media (min-width: 2048px) {}

/* 2304-1470 */
@media (min-width: 2304px) {
    .no-subscription {
        // padding: 190px 120px;

        h3 {
            font-size: 36px;
        }

        .message {
            font-size: 18px;
            margin-top: 20px;
            margin-bottom: 30px;
        }

        button {
            width: 200px !important;

            p {
                font-size: 16px !important;
            }
        }
    }

    .notification-files {
        gap: 40px;

        .file {
            p {
                font-size: 14px;
            }

            img {
                width: 22px;
                height: 30px;
            }
        }
    }

    .files-toggle-btn {
        width: 24px;
        height: 24px;
    }

    .download-btn {
        width: 240px;

        p {
            font-size: 16px;
        }
    }
}

/* 2470 - 1328 */
@media (min-width: 2470px) {
    .no-subscription {
        h3 {
            font-size: 38px;
        }

        .message {
            font-size: 20px;
        }

        button {
            p {
                font-size: 18px !important;
            }
        }
    }

    .notifications-list-wrapper {
        .header .counter p {
            font-size: 20px;
        }

        .notifications-list .notification {
            .company-img {
                width: 50px;
                height: 50px;
            }

            .about {
                .company p {
                    font-size: 20px;
                }

                .recieved-date p {
                    font-size: 16px;
                }
            }
        }
    }

    .noticications-details {
        .header .about .status p {
            font-size: 16px;
        }

        .details p {
            font-size: 16px;
        }
    }

    .action-btns .dsb-btn p {
        font-size: 18px;
    }
}

/* imac retina */
/*2560-1440*/
@media (min-width: 2560px) {
    .no-subscription {
        // padding: 200px 130px;

        .message {
            margin-top: 30px;
            margin-bottom: 40px;
        }

        button {
            width: 220px !important;
        }
    }

    .notification-files {
        gap: 45px;

        .file {
            p {
                font-size: 16px;
            }

            img {
                width: 24px;
                height: 32px;
            }
        }
    }

    .files-toggle-btn {
        width: 26px;
        height: 26px;
    }

    .download-btn {
        width: 250px;
    }
}

/*2573-1206*/
@media(min-width: 2573px) {}

/* 2880-1670 */
@media(min-width: 2880px) {
    .no-subscription {
        h3 {
            font-size: 40px;
        }

        .message {
            font-size: 22px;
        }

        button {
            p {
                font-size: 20px !important;
            }
        }
    }

    .notifications-list-wrapper {
        .header .counter p {
            font-size: 22px;
        }

        .notifications-list .notification {
            .company-img {
                width: 55px;
                height: 55px;
            }

            .about {
                .company p {
                    font-size: 22px;
                }

                .recieved-date p {
                    font-size: 18px;
                }
            }
        }
    }

    .noticications-details {
        .header .about .status p {
            font-size: 18px;
        }

        .details p {
            font-size: 18px;
        }
    }

    .action-btns .dsb-btn p {
        font-size: 20px;
    }

    .notification-files {
        gap: 50px;

        .file {
            p {
                font-size: 18px;
            }

            img {
                width: 26px;
                height: 34px;
            }
        }
    }

    .files-toggle-btn {
        width: 28px;
        height: 28px;
    }

    .download-btn {
        width: 280px;

        p {
            font-size: 18px;
        }
    }
}

/* 3000-1870 */
@media(min-width: 3000px) {}

/*3200-1800*/
@media(min-width: 3200px) {
    .no-subscription {
        // padding: 220px 150px;

        h3 {
            font-size: 42px;
        }

        .message {
            font-size: 24px;
            margin-top: 40px;
            margin-bottom: 50px;
        }

        button {
            width: 250px !important;

            p {
                font-size: 22px !important;
            }
        }
    }

    .notifications-list-wrapper {
        .header .counter p {
            font-size: 24px;
        }

        .notifications-list .notification {
            .company-img {
                width: 60px;
                height: 60px;
            }

            .about {
                .company p {
                    font-size: 24px;
                }

                .recieved-date p {
                    font-size: 20px;
                }
            }
        }
    }

    .noticications-details {
        .header .about .status p {
            font-size: 20px;
        }

        .details p {
            font-size: 20px;
        }
    }

    .action-btns .dsb-btn p {
        font-size: 22px;
    }

    .notification-files {
        gap: 55px;

        .file {
            p {
                font-size: 18px;
            }

            img {
                width: 28px;
                height: 36px;
            }
        }
    }

    .files-toggle-btn {
        width: 30px;
        height: 30px;
    }

    .download-btn {
        width: 300px;

        p {
            font-size: 20px;
        }
    }
}

/*3360-1890 1695*/
@media(min-width:3360px) {}

/* 3840 x 2160 2049 (4K) */
@media(min-width:3840px) {
    .no-subscription {
        h3 {
            font-size: 46px;
        }

        .message {
            font-size: 28px;
        }

        button {
            width: 280px !important;

            p {
                font-size: 26px !important;
            }
        }
    }

    .notifications-list-wrapper {
        .header .counter p {
            font-size: 28px;
        }

        .notifications-list .notification {
            .company-img {
                width: 70px;
                height: 70px;
            }

            .about {
                .company p {
                    font-size: 28px;
                }

                .recieved-date p {
                    font-size: 24px;
                }
            }
        }
    }

    .noticications-details {
        .header .about .status p {
            font-size: 24px;
        }

        .details p {
            font-size: 24px;
        }
    }

    .action-btns .dsb-btn p {
        font-size: 26px;
    }

    .notification-files {
        gap: 65px;

        .file {
            p {
                font-size: 20px;
            }

            img {
                width: 32px;
                height: 40px;
            }
        }
    }

    .files-toggle-btn {
        width: 35px;
        height: 35px;
    }

    .download-btn {
        width: 350px;

        p {
            font-size: 24px;
        }
    }
}

/* 1920x961 (current) */

/* macbook pro 16 2021 */
/*1728x1085*/
@media(max-width: 1728px) {
    .no-subscription {
        // padding: 160px 100px;

        h3 {
            font-size: 30px;
        }
    }
}

/*1688-1080*/
@media(max-width: 1688px) {}

/*1680-1080*/
@media(max-width: 1680px) {
    // .no-subscription {
    //     padding: 140px 90px;
    // }

    .notifications-list-wrapper {
        .header .counter p {
            font-size: 14px;
        }

        .notifications-list .notification {
            .company-img {
                width: 40px;
                height: 40px;
            }

            .about {
                .company p {
                    font-size: 16px;
                }

                .recieved-date p {
                    font-size: 12px;
                }
            }
        }
    }

    .noticications-details {
        .header .about .status p {
            font-size: 14px;
        }

        .details p {
            font-size: 14px;
        }
    }

    .action-btns .dsb-btn {
        width: 140px;

        p {
            font-size: 14px;
        }
    }

    .notification-files {
        gap: 30px;

        .file img {
            width: 18px;
            height: 26px;
        }
    }

    .files-toggle-btn {
        width: 20px;
        height: 20px;
    }

    .download-btn {
        width: 200px;
    }
}

/*1640-1080*/
@media(max-width: 1640px) {}

/* 1600 - 757 */
@media (max-width: 1600px) {
    // .no-subscription {
    //     padding: 120px 80px;
    // }

    .notification-files {
        gap: 25px;

        .file img {
            width: 16px;
            height: 24px;
        }
    }

    .files-toggle-btn {
        width: 18px;
        height: 18px;
    }

    .download-btn {
        width: 180px;
    }
}

/*1536-864*/
@media(max-width:1536px) {
    .no-subscription {
        button {
            width: 160px !important;
        }
    }
}

/* macbook pro/air */
/* 1440-900 */
@media(max-width:1440px) {
    .no-subscription {
        // padding: 100px 60px;

        h3 {
            font-size: 26px;
        }
    }

    .noticications-details {
        .header .about .status p {
            font-size: 12px;
        }

        .details p {
            font-size: 12px;
        }
    }

    .notification-footer {
        padding-top: 70px;
    }
}

/*1366-638*/
@media (max-width:1366px) {
    .no-subscription {
        //padding: 80px 20px;

        h3 {
            font-size: 24px;
        }

        button {
            width: 120px !important;

            p {
                font-size: 12px !important;
            }
        }
    }

    .notifications-list-wrapper {
        padding: 30px 15px;
    }

    .noticications-details .header {
        padding: 25px;
    }

    .noticications-details .details {
        padding: 15px 25px;
        padding-bottom: 70px;
    }

    .action-btns {
        gap: 25px;
    }

    .notification-files {
        gap: 20px;

        .file img {
            width: 14px;
            height: 22px;
        }
    }

    .notification-files {
        padding: 25px;
    }

    .notification-footer {
        padding: 25px;
        padding-top: 60px;
    }
}

/* macbook air */
/* 1280-800 */
@media (max-width:1280px) {
    .notifications-list-wrapper {
        .notifications-list .notification {
            .company-img {
                width: 35px;
                height: 35px;
            }

            .about {
                .company p {
                    font-size: 14px;
                }
            }
        }
    }

    .action-btns .dsb-btn {
        width: 130px;
    }
}

/* 1200-1920 */
@media (max-width:1200px) {
    .no-subscription {
        //padding: 60px 20px;

        h3 {
            font-size: 22px;
        }

        .message {
            font-size: 13px;
            margin-top: 15px;
            margin-bottom: 25px;
        }
    }

    .notifications-list-wrapper {
        padding: 25px 10px;
    }

    .noticications-details .header {
        padding: 15px;
    }

    .noticications-details .details {
        padding: 15px;
        padding-bottom: 60px;
    }

    .notification-files {
        padding: 20px 15px;
    }

    .notification-footer {
        padding: 20px 15px;
        padding-top: 50px;
    }

    .files-toggle-btn {
        top: 20px;
        right: 20px;
    }

    .action-btns {
        gap: 15px;
    }
}

/*1134x712*/
@media(max-width:1134px) {
    .noticications-details .details {
        padding-bottom: 50px;
    }

    .dsb-btn p {
        font-size: 12px;
    }

    .action-btns {
        gap: 10px;
    }

    .notification-footer {
        padding-top: 40px;
    }
}

/* tablets */

/* micro duo */
/*1114x705*/
@media(max-width:1114px) {}

/*1024-768*/
/* ipad pro */
/*1024-1366*/
@media (max-width:1024px) {
    .no-subscription {
        //padding: 50px 20px;

        h3 {
            font-size: 20px;
        }

        .message {
            font-size: 12px;
            margin-top: 10px;
            margin-bottom: 20px;
        }
    }

    .notifications-list-wrapper {
        padding: 25px 10px;
    }

    .noticications-details .header {
        padding: 15px;
    }

    .noticications-details .details {
        padding: 15px;
        padding-bottom: 40px;
    }

    .notifications-list-wrapper .notifications-list .notification {
        padding: 8px;
    }

    .notifications-list-wrapper {
        .header .counter p {
            font-size: 12px;
        }

        .notifications-list .notification {
            .company-img {
                width: 32px;
                height: 32px;
            }

            .about {
                .company p {
                    font-size: 12px;
                }

                .recieved-date p {
                    font-size: 10px;
                }
            }
        }
    }

    .noticications-details {
        .header .about .status p {
            font-size: 11px;
        }

        .details p {
            font-size: 11px;
        }
    }

    .action-btns .dsb-btn {
        width: 120px;

        p {
            font-size: 12px;
        }
    }
}

/* ipad pro 2/3 */
/* 981x1024 */
@media (max-width:981px) {}

/* 962x601 */
@media(max-width: 962px) {
    .download-btn {
        width: 160px;
    }
}

/* 900x1600 */
@media(max-width: 900px) {

    .notification-footer,
    .action-btns {
        gap: 5px;
    }

    .no-subscription {
        //padding: 40px 20px;

        h3 {
            font-size: 18px;
        }
    }
}

/* galaxy fold */
/* 884 x 1104 */
@media(max-width: 884px) {}

/* ipad pro 2022 */
/*834-1136*/
@media(max-width: 834px) {
    .notifications-wrapper {
        flex-direction: column;
    }

    .notifications-list-wrapper,
    .noticications-details,
    .no-data-msg {
        width: 100%;
    }

    .notifications-list-wrapper {
        border-right-color: transparent;
        border-bottom-color: #7070704d;
    }

    .notifications-list-wrapper {
        padding: 30px 20px;
    }

    .noticications-details .header {
        padding: 20px;
    }

    .noticications-details .details {
        padding: 15px 20px;
        padding-bottom: 40px;
    }

    .notifications-list-wrapper .notifications-list .notification {
        padding: 10px;
    }

    .notifications-list-wrapper {
        .header .counter p {
            font-size: 14px;
        }

        .notifications-list .notification {
            .company-img {
                width: 38px;
                height: 38px;
            }

            .about {
                .company p {
                    font-size: 14px;
                }

                .recieved-date p {
                    font-size: 12px;
                }
            }
        }
    }

    .noticications-details {
        .header .about .status p {
            font-size: 12px;
        }

        .details p {
            font-size: 11px;
        }
    }

    .action-btns .dsb-btn {
        width: 120px;

        p {
            font-size: 12px;
        }
    }

    .notification-files {
        padding: 15px 20px;
    }

    .notification-footer {
        padding: 15px 20px;
        padding-top: 40px;
    }

    .notification-footer,
    .action-btns {
        gap: 10px;
    }
}

/* ipad air 4 */
/* 820x1180 */
@media(max-width: 820px) {}

/* ipad 2020 */
/* 810x1080 */
@media(max-width: 810px) {}

/* galaxy tab 7 */
/* 800x1280 */
@media(max-width: 800px) {}

/*778-304*/
@media(max-width: 778px) {}

/*775*/
@media(max-width: 775px) {}

/* ipad air/mini */
/* 768x1024 */
@media(max-width: 768px) {
    .files-toggle-btn {
        top: 18px;
        right: 18px;
        width: 16px;
        height: 16px;
    }
}

/*712-1138*/
@media(max-width:712px) {}

/* ipad air 2/3 */
/* 694-768 */
@media(max-width:694px) {}

/* ipad pro 1/2 */
/* 678-1024 */
@media(max-width:678px) {}

/* 600x962 */
@media(max-width:600px) {}

/* 577-951 */
@media(max-width:577px) {}

/* 540-960 */
@media(max-width:540px) {}

/* mobiles */

/* s-note */
/*480-853*/
@media (max-width:480px) {
    .download-btn {
        p {
            font-size: 10px;
        }
    }

    .action-btns .dsb-btn {
        width: 110px;
    }
}

/* ipad air 2/3 */
/*438-1024*/
@media(max-width:438px) {
    .notification-files .file {
        gap: 5px;

        img {
            width: 12px;
            height: 20px;
        }
    }

    .action-btns {
        gap: 30px;
    }

    .notification-footer {
        gap: 30px;
        flex-direction: column-reverse;
    }

    .download-btn {
        width: 180px;

        p {
            font-size: 12px;
        }
    }
}

/* ip14 pro max */
/* 430x932 */
@media(max-width:430px) {
    // .no-subscription {
    //     padding: 30px 20px;
    // }
}

/* ip13 pro max */
/* 428-926 */
@media (max-width:428px) {}

/* ip11 pro max */
/* 414-896/736*/
@media (max-width:414px) {}

/* s21 ultra, pix6 */
/* 412-915*/
/* heights: 732, 824, 846, 869, 892, 906, 915, 919 */
@media (max-width:412px) {}

/* ip14 pro, pix5 */
/*393 x 852*/
@media(max-width:393px) {}

/* ip13 pro */
/*390 x 844*/
@media(max-width:390px) {}

/* s21 plux */
/*384-854*/
@media(max-width:384px) {}

/* ip X */
/*375-812/667*/
@media(max-width:375px) {}

/* s22 ultra */
/*360x772*/
@media(max-width:360px) {}

/* ip SE */
/*320x568*/
@media(max-width:320px) {
    .no-subscription h3 {
        font-size: 16px;
    }
}
</style>
